import React from "react";
import { Col, Row } from "antd";
import { observer } from "mobx-react";
import Text from "../DeclarantGrid/Summary";
import { IDeclarantSummary } from "./Interfaces";
import { OTHERS_KEY } from "../../constants/measureCodes";

interface Props {
  store: IDeclarantSummary;
}

const GUTTER = 15;

const Summary: React.FC<Props> = ({ store }) => (
  <Row gutter={GUTTER} justify="end" align="bottom">
    <Col>
      <Row gutter={GUTTER}>
        <Col key="titles">
          <div className="summary-rows">
            <p>&nbsp;</p>
            <p key="general-title">General:</p>
            <p key="selected-title">Selected:</p>
          </div>
        </Col>
        {store.summary.map((item) => (
          <Col key={item.key}>
            <Text
              name={item.key}
              general={item.general}
              total={item.selected}
            />
          </Col>
        ))}
      </Row>
    </Col>
    <Col>
      <div>
        <Row justify="center">
          <div className="summary-head">Measure Code</div>
        </Row>
        <Row gutter={GUTTER}>
          {store.measureCodes.map((item) => (
            <Col key={item.key}>
              <Text
                name={item.key}
                general={item.general}
                total={item.selected}
                fractionDigits={0}
                className={
                  item.key === OTHERS_KEY ? "summary summary-center" : "summary"
                }
              />
            </Col>
          ))}
        </Row>
      </div>
    </Col>
  </Row>
);

export default observer(Summary);
